import React from "react";

import Blocks from "components/form/Blocks";

import useRugianoProjectApi from "hooks/api/private/useRugianoProjectApi";

function RugianoProjectBlocksForm({ projectId }: { projectId: string }) {
    const { getOneRugianoProject } = useRugianoProjectApi();

    const [blockGroupId, setBlockGroupId] = React.useState<string | null>(null);

    React.useEffect(() => {
        const [apiCall, abortController] = getOneRugianoProject({ id: projectId });

        apiCall.then((project) => setBlockGroupId(project.block_group_id));

        return () => abortController.abort();
    }, [getOneRugianoProject, projectId]);

    return <>{blockGroupId && <Blocks blockGroupId={blockGroupId} />}</>;
}

export default RugianoProjectBlocksForm;
